import { message, Select } from "antd";
import React, { useEffect, useState } from "react";
import { GetRequest, PostRequest } from "../../Api/ApiFunctions";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";

const AssignAccount = ({ FetchNewData, selectedEmployee }) => {
  const {
    register,
    handleSubmit,
    // setValue,
    reset,
    // formState: { isSubmitting },
  } = useForm();
  const { Option } = Select;
  const Entity = ["PMITS", "EXPO", "MESR", "PMECO"];

  const [salesPersonData, setSalesPersonData] = useState(["sa", "ba"]);
  const [availableAccounts, setAvailableAccounts] = useState([]);
  const [assignedAccounts, setAssignedAccounts] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState(null);
  //   const [as]
  const fetchData = async () => {
    const res = await GetRequest("all-accounts");
    if (res) {
      setAvailableAccounts(res?.accounts ?? []);
      setSalesPersonData(res?.salesPerson ?? []);
      //  { accounts: allAccounts, salesPerson: allSalesPerson }
      // setAssignedAccounts();
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    console.log(selectedEmployee, "this");

    const newAccountsToAdd =
      selectedEmployee?.accounts?.filter(
        (acc) => !assignedAccounts?.some((subAcc) => subAcc.id === acc.id)
      ) || [];
    if (newAccountsToAdd?.length > 0) {
      console.log(newAccountsToAdd, "again");
      setAssignedAccounts((prev) => [...newAccountsToAdd, ...prev]);
    }
  }, [selectedEmployee]);

  const resetAll = () => {
    FetchNewData();
    reset();
    setAssignedAccounts([]);
    const mdl1 = document.querySelector(
      `#assign-account [data-bs-dismiss="modal"]`
    );
    const mdl2 = document.querySelector(
      `#new-employee [data-bs-dismiss="modal"]`
    );
    if (mdl1) {
      mdl1.click();
    }
    if (mdl2) {
      mdl2.click();
    }
  };

  const AddNewEmployee = async (data, event) => {
    event.preventDefault();
    if (!data.new_name) {
      message.warning("Name is required.");
      return;
    }
    const res = await PostRequest("empl", {
      name: data.new_name,
      salesperson_name: data.new_salesperson,
      active: true,
    });
    if (res) {
      resetAll();
    }
  };

  const AssignEmployee = async () => {
    // event.preventDefault();
    const res = await PostRequest("empl/assign", {
      employeeId: selectedEmployee?.id,
      accounts: assignedAccounts.map((it) => parseInt(it.id)),
    });
    if (res) {
      resetAll();
      message.success("Accounts Assigned Successfully");
    }
  };

  return (
    <div>
      {/* Add Unit */}
      <div className="modal fade" id="assign-account">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Assign Account</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={resetAll}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <div className="mb-3">
                    <label className="form-label">Books</label>
                    <select
                      className="form-control"
                      value={selectedEntity}
                      onChange={(e) => setSelectedEntity(e.target.value)}
                    >
                      <option value={null}>All</option>
                      {Entity.map((it) => (
                        <option key={it} value={it}>
                          {it}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="form-label">Accounts</label>
                    <Select
                      mode="multiple"
                      showSearch
                      allowClear
                      style={{ width: "100%" }}
                      placeholder="Select accounts"
                      value={assignedAccounts?.map((acc) => acc.id)}
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode
                      }
                      onChange={(selectedIds) => {
                        const selected = availableAccounts
                          .filter((acc) => selectedIds.includes(acc.id))
                          .map((dt) => ({
                            id: dt.id,
                            name: dt.account_name,
                          }));
                        setAssignedAccounts(selected);

                        // selectedEntity
                        //   ? availableAccounts.filter(
                        //       (it) => it.key === selectedEntity
                        //     )
                        //   :
                      }}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {availableAccounts
                        .filter((it) => {
                          if (
                            selectedEntity !== null &&
                            selectedEntity !== undefined
                          ) {
                            return it.key === selectedEntity;
                          }
                          return true;
                        })
                        .map((acc) => (
                          <Option key={acc.id} value={acc.id}>
                            {acc.account_name}
                          </Option>
                        ))}
                    </Select>
                  </div>

                  <div className="modal-footer-btn">
                    <button
                      type="button"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                      onClick={resetAll}
                    >
                      Cancel
                    </button>
                    <button className="btn btn-submit" onClick={AssignEmployee}>
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Unit */}

      <div className="modal fade" id="new-employee">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>New Employee</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={handleSubmit(AddNewEmployee)}>
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("new_name", {
                          required: "name is required",
                        })}
                      />
                    </div>

                    <div className="" style={{ width: "100%" }}>
                      <label className="form-label">SalesPerson</label>

                      <select
                        className="form-control"
                        {...register("new_salesperson")}
                      >
                        <option value="" disabled hidden>
                          Select a salesperson
                        </option>
                        <option value="">No Salesperson</option>
                        {salesPersonData?.map((dt, i) => (
                          <option key={i} value={dt}>
                            {dt}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button className="btn btn-submit">Create Unit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AssignAccount.propTypes = {
  FetchNewData: PropTypes.func, // ✅ define it as a function
  selectedEmployee: PropTypes.object,
  // Add other props here if needed
};

export default AssignAccount;
